import React, { useState, useEffect ,useContext} from "react";
import { AuthService } from "../../api/AuthService";
import { ObjectLiteral } from "../../interfacesProps/ObjectLiteralProps";
import { RBCardView } from "../../components/RBCardView";
import { Spacing, Colors,} from "../../theme/Theme";
import {
  useTheme,
} from "@material-ui/core";
import { useLocation, useHistory } from "react-router";
import { RBContext } from "../../components/RBContext";
import { IndustryModeEnum,paymentTypeEnum,formatPaymentType } from "../../api/constants";
import {  ColumnStyle } from "../../theme/ComponentTheme";
import { RBAppbar } from "../../components/RBAppbar";
import { RBButton } from "../../components/RBButton";
import { LoadingIndicator } from "../../components/LoadingIndicator";
import CreditCard from "@material-ui/icons/CreditCard";
import { RBModal } from "../../components/RBModal";
import { RBEmptyBlock } from "../../components/RBEmptyBlock";
import { RBAlert } from "../../components/RBAlert";
import { renderRBPayText } from "../../components/RBPayWordmark";
import { PharmacyService }  from "../../api/PharmacyService";
import { ShiftService } from "../../api/ShiftService";
import { RoutePathConstant } from "../../util/Common";
import { formatPaymentVerificationType, stripePadVerificationTypeEnum } from "../../util/Common";
import { rbPayrollOwnerService } from "../rbPayrollOwnerSettings/services/rbPayrollOwner.service";
import { isRBPayPaymentMethod } from "../../util/rbPay";
import { AccountInfoContext } from "../../components/AccountInfoContext";
interface PaymentOptionPageProps {}
interface LocationState {
    tabType?: string;
    editMode?: boolean;
    newPharmacy?: boolean;
    selectedLoc?:ObjectLiteral;
  }
export const PaymentOption: React.FC<PaymentOptionPageProps> = ({
    ...props
  }) => {
    
  const history = useHistory();
  const location = useLocation<LocationState>();
  const { tabType, editMode, newPharmacy, selectedLoc } = location.state || {};
  const { industryMode,primaryColor,secondaryColor } = useContext(RBContext);
  const [optionsArr , setOptionsArr] = useState<any>([]);
  const [selectedTransaction, setSelectedTransaction] = useState<any>(null);
  const [newPaymentType, setNewPaymentType] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedLocations, setSelectedLocations] = useState<any>([])
  const [showPopup, setShowPopup] = useState(false);
  const [rbPayReactivatedOpen, setRbPayReactivatedOpen] = useState(false);
  const [availablePaymentInfo, setAvailablePaymentInfo] = useState<any>(null);
  const [availablePaymentInfoArr , setAvailablePaymentInfoArr] = useState<any>([]);
  const [selectedPaymentInfo , setSelectedPaymentInfo] = useState(null);
  const [pharmacyDetails, setPharmacyDetails] = useState<any>([]);
  const [account, setAccount] = useState<any>([]);
  const [isAlertShowing, setIsAlertShowing] = useState(false);
  const [alertInfo,setAlertInfo]  = useState <any> ({title:"",message:"", buttons:[]})
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [showVerificationPopup, setShowVerificationPopup] = useState(false);
  const [selectedVerificationType, setSelectedVerificationType] = useState(stripePadVerificationTypeEnum.Instant);
  const [disabledPaymentMethods, setDisabledPaymentMethods] = useState<string[]>([]);
  const [currentPaymentIsInvoice, setCurrentPaymentIsInvoice] = useState(false);
  const [networkAdminInfo, setNetworkAdminInfo] = useState<any>(null);
  const [rbPayrollOptions, setRbPayrollOptions] = useState<any[]>([]);

  const getActivePharmacy = () => {
    if (pharmacyDetails?.id) {
      return pharmacyDetails;
    }
    return selectedLoc ?? null;
  };

  const { accountInformation, fetchPharmacy } = useContext(AccountInfoContext);

  useEffect(() => {
    
      (async () => {

        if (!accountInformation) return;

        //
        const userData = accountInformation;
        setAccount(userData)
        const selectedPharmacyId = selectedLoc?.id || userData.owner.defaultPharmacyId;
        let pharmaDetails = await fetchPharmacy(selectedPharmacyId);
        setPharmacyDetails(pharmaDetails)
        setSelectedLocations([pharmaDetails])
        const pharmacy = pharmaDetails;
        localStorage.setItem("stripePharmacyId",pharmacy.id);
        const nextRBPayrollOptions = await rbPayrollOwnerService.getPaymentOptions({
          account: userData,
          location: pharmacy,
        });
        setRbPayrollOptions(nextRBPayrollOptions);

        // Fetch network admin info for DSO/Care Group message
        if (pharmacy.networkId) {
          try {
            const networkInfo = await ShiftService.getNetworkAdminInfo(pharmacy.networkId);
            setNetworkAdminInfo(networkInfo);
          } catch (e) {
            console.log("Unable to fetch network admin info", e);
          }
        }
       

        // Resolve disabled payment methods from backend
        // pharmacy.disabledPaymentMethods is an array of payment types the owner cannot select
        // e.g. ["invoice"] means Traditional Invoice is hidden
        const resolvedDisabled: string[] = pharmacy.disabledPaymentMethods ?? [];
        
        console.log("Resolved disabledPaymentMethods:", resolvedDisabled);
        setDisabledPaymentMethods(resolvedDisabled);

       // Build all possible payment options with surcharge info
       const allPaymentOptions: Array<{
        type: string;
        paymentType: string;
        surchargeFixed?: any;
        surchargePercentage?: any;
        padSurchargeMaxCap?: any;
        invoicePercentage?: any;
        isCurrentLegacy?: boolean;
        description?: string;
        setupStatus?: string;
        approved?: boolean;
       }> = [
        {
          type: formatPaymentType(paymentTypeEnum.pad),
          paymentType: paymentTypeEnum.pad,
          surchargeFixed: pharmacy.padSurchargeFixed,
          surchargePercentage: pharmacy.padSurchargePercentage,
          padSurchargeMaxCap:pharmacy.padSurchargeMaxCap
        },
        {
          type: formatPaymentType(paymentTypeEnum.creditCard),
          paymentType: paymentTypeEnum.creditCard,
          surchargeFixed: pharmacy.ccSurchargeFixed,
          surchargePercentage: pharmacy.ccSurchargePercentage,
         
        },
        {
          type: formatPaymentType(paymentTypeEnum.invoice),
          paymentType: paymentTypeEnum.invoice,
          invoicePercentage: pharmacy.invoiceSurchargePercentage
        },
        ...nextRBPayrollOptions.map((option) => ({
          type: option.title,
          paymentType: paymentTypeEnum.rbPayroll,
          description: option.description,
          setupStatus: option.setupStatus,
          approved: option.approved,
        })),
      ];

      // Filter out payment methods disabled by backend
      const transactionArray = allPaymentOptions.filter(
        (item) => !resolvedDisabled.includes(item.paymentType)
      );

      // In edit mode: if the pharmacy's current paymentType was filtered out (disabled by admin),
      // re-inject it at the top as a legacy entry so the owner can see their current state.
      // It is marked isCurrentLegacy=true so the UI can distinguish it from selectable options.
      let displayArray = [...transactionArray];
      const currentOption = allPaymentOptions.find(
        (item) => item.paymentType === pharmacy.paymentType
      );
      const isCurrentDisabled =
        currentOption && resolvedDisabled.includes(currentOption.paymentType);

      if (editMode && isCurrentDisabled && currentOption) {
        displayArray = [
          { ...currentOption, isCurrentLegacy: true },
          ...transactionArray,
        ];
      }

      setOptionsArr(displayArray);

      //if edit mode is off default will be PAD otherwise already available payment type
      if(editMode)
      {
        console.log("pharmacynew",pharmacy)
        // Preselect the location's CURRENT method (pharmacy.paymentType). The
        // method comes back as "rb_pay", but the RB Pay option in the list uses
        // paymentTypeEnum.rbPayroll ("rb_payroll"), so map that case explicitly.
        // The mock `selected` flag is deliberately NOT used: it isn't cleared when
        // switching away (e.g. to Credit Card), so it would wrongly keep RB Pay
        // preselected even after the location moved to another method.
        const isPharmacyOnRBPay = isRBPayPaymentMethod(pharmacy.paymentType);
        const preselect = isPharmacyOnRBPay
          ? displayArray.find((item) => item.paymentType === paymentTypeEnum.rbPayroll)
          : displayArray.find(item => item.paymentType === pharmacy.paymentType);
        setSelectedTransaction(preselect || displayArray[0]);
        // treat legacy entry as needing new payment setup if user switches away
        setNewPaymentType(!preselect || !!isCurrentDisabled);
        if (isCurrentDisabled && pharmacy.paymentType === paymentTypeEnum.invoice) {
          setCurrentPaymentIsInvoice(true);
        }
      }
      else{
        setSelectedTransaction(displayArray[0])
        setNewPaymentType(true)
      }
       setIsPageLoading(false);
      })();       
      
  }, [accountInformation])


useEffect(() => {
  if (!showVerificationPopup && optionsArr.length > 0) {
    setTimeout(() => {
      setSelectedTransaction(optionsArr[0]); // Reset to first option when popup closes
    }, 0); // Forces an immediate update after re-render
  }
}, [showVerificationPopup]);

   const stripePricingURL = 'https://stripe.com/en-ca/pricing';
//   const handleLinkPress = () => {
//     Linking.openURL(stripePricingURL);
//   };
const closePopup = () =>{
  setShowPopup(false)
}
const handleVerificationType = (type:any) => {
  setSelectedVerificationType(type);
};


const closeVerificationPopup = () => {
  setShowVerificationPopup(false)
  if (optionsArr.length > 0) {
    setSelectedTransaction(optionsArr[0]); 
  } else {
    setSelectedTransaction(null); // Handle edge case if array is empty
  }
}

  const handleCCPaymentInfoChange = (index:any) => {
    setSelectedPaymentInfo(availablePaymentInfoArr[index])
    setAvailablePaymentInfo(availablePaymentInfoArr[index])
  }
  const renderPaymentInfo = () =>{
    return(
      <>
        {availablePaymentInfoArr.length > 0 && 
        <div style={{ flex: 1 }}>
          <div style={{paddingBottom:18}}>
          You have the following credit cards set up. If you would like to use one of these, please select the applicable card and select “Yes”. If you would like to add a new one, please select “No, Add New”.
          </div>
          {availablePaymentInfoArr.map((payment:any, index:number) => {
            
            return (
              <div onClick={() => handleCCPaymentInfoChange(index)} >
                <div style={{
                  borderWidth: 2,
                  borderColor: primaryColor,
                  borderRadius: 5,
                  cursor:"pointer"
                }}>
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                    <style>{`
                      input[type="radio"]:checked {
                        accent-color: ${secondaryColor};
                      }
                    `}</style>
                      <input
                        type="radio"
                        id="paymentOption"
                        name="paymentOption"
                        value={payment.type}
                        checked={selectedPaymentInfo === availablePaymentInfoArr[index]}
                        onChange={() => handleCCPaymentInfoChange(index)}
                      />
                      <CreditCard style={{ marginLeft: 10 }} /> {/* Adjust styling as needed */}
                      <div style={{ paddingLeft: 10 }}>{payment.type} ending with {payment.lastFourDigits}</div>
                    </div>
                  </div>

                  <div style={{ marginLeft: 50, marginBottom: 15 }}>
                      <>
                        <div style={{ paddingLeft: 16 }}>
                          Expires: {payment.expiryMonth}/{payment.expiryYear}
                        </div>
                      </>
                    
                  </div>

                </div>
              </div>
            )
          })}
        </div>}
      </>
    )
  }
  const renderPaymentPopupModal = () => {
    const pharmacy = getActivePharmacy();
    return (
      <div
        style={{
          backgroundColor: Colors.defaultGrey,
          display: "flex",
          flex: 1,

        }}
      >
        
          <RBCardView
            style={{
              flex: 1,
              marginLeft: Spacing.large,
              marginRight: Spacing.large,
              marginBottom: Spacing.smallest,
              paddingLeft: Spacing.large,
              paddingTop: Spacing.large,
              paddingRight: Spacing.large,
              paddingBottom: Spacing.large,
            }}
          >
            <div>
          
               {availablePaymentInfoArr.length > 0 ?
                  <div>
                      {renderPaymentInfo()}
                  </div>
                :
                  <div>
                    {selectedTransaction.paymentType === paymentTypeEnum.pad && <div >
                      You have the bank account ending in {availablePaymentInfo?.accountNumberLastFour} set up. Do you want to use this account?
                    </div>}
                    {selectedTransaction.paymentType === paymentTypeEnum.creditCard && <div>
                      You have the credit card ending in {availablePaymentInfo?.lastFourDigits} set up. Do you want to use this card?
                    </div>}
                  </div>
                }
    
            
            </div>
          <div
            style={{
              display: "flex",
              flex: 1,
              alignItems: "flex-end",
            }}
          >

            <RBButton
              style={{
                display: "flex",
                flex: 1,
                padding: Spacing.medium,
                margin: Spacing.large,
              }}
              buttonBackgroundColor={secondaryColor}
              onClick={() => {
                setLoading(true)
                setShowPopup(false)
                saveInvoicePayment(selectedTransaction.paymentType, selectedTransaction.paymentType === paymentTypeEnum.pad ? false : (availablePaymentInfo?.category == 'job' ? true : false))
              }}
              text="Yes"
            />
            <RBButton
              style={{
                display: "flex",
                flex: 1,
                padding: Spacing.medium,
                margin: Spacing.large,
              }}
              buttonBackgroundColor={secondaryColor}
              onClick={() => {
                setShowPopup(false)
                if (selectedTransaction.paymentType === paymentTypeEnum.pad) {
                  setShowVerificationPopup(true)
                }
                else if (selectedTransaction.paymentType === paymentTypeEnum.creditCard) {
                  const selectedLocation = [pharmacy];
                  history.push('/paymentCreditInput', {
                    selectedLocation: selectedLocation,
                    payType: 'Shift'
                  });
                }

              }}
              text="No, Add New"
            />
          </div>
            
          </RBCardView>
       
      </div>
    );
  };

  const renderVerificationModal = () => {
    return (
      <RBCardView
        style={{
          flex: 1,
          margin: Spacing.large,
          padding: Spacing.large,
        }}
      >
        <div style={{ flex: 1 }}>
          {/* Title */}
          <div style={{ marginBottom: Spacing.medium, fontWeight: "bold" }}>
            Please select the verification type to proceed.
          </div>

          {/* Options Container */}
          <div style={{ display: "flex", flexDirection: "column", gap: Spacing.medium }}>
            {/* Instant Verification Option */}
            <div
              onClick={() => handleVerificationType(stripePadVerificationTypeEnum.Instant)}
              style={{
                borderWidth: 2,
                borderColor: primaryColor,
                borderRadius: 5,
                cursor: "pointer",
                padding: Spacing.medium,
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
              <style>{`
                input[type="radio"]:checked {
                  accent-color: ${secondaryColor};
                }
              `}</style>
                <input
                  type="radio"
                  id="instantVerification"
                  name="verificationOption"
                  checked={selectedVerificationType === stripePadVerificationTypeEnum.Instant}
                  onChange={() => handleVerificationType(stripePadVerificationTypeEnum.Instant)}
                />
                <label htmlFor="instantVerification" style={{ marginLeft: Spacing.small }}>
                  {formatPaymentVerificationType(stripePadVerificationTypeEnum.Instant)}
                </label>
              </div>
              <div style={{ color: "gray", marginLeft: 30 }}>
                * This payment verification process will take approximately 5–10 minutes to complete.
              </div>
            </div>

            {/* Micro Deposits Option */}
            <div
              onClick={() => handleVerificationType(stripePadVerificationTypeEnum.MicroDeposits)}
              style={{
                borderWidth: 2,
                borderColor: primaryColor,
                borderRadius: 5,
                cursor: "pointer",
                padding: Spacing.medium,
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
              <style>{`
                input[type="radio"]:checked {
                  accent-color: ${secondaryColor};
                }
              `}</style>
                <input
                  type="radio"
                  id="microDepositsVerification"
                  name="verificationOption"
                  checked={selectedVerificationType === stripePadVerificationTypeEnum.MicroDeposits}
                  onChange={() => handleVerificationType(stripePadVerificationTypeEnum.MicroDeposits)}
                />
                <label htmlFor="microDepositsVerification" style={{ marginLeft: Spacing.small }}>
                  {formatPaymentVerificationType(stripePadVerificationTypeEnum.MicroDeposits)}
                </label>
              </div>
              <div style={{ color: "gray", marginLeft: 30 }}>
                * Micro-deposit verification may take 1–2 business days to complete.
                At this time, your default payment type will become Traditional Invoice so that you can still post shifts.
              </div>
            </div>
          </div>

          {/* Buttons - Aligned in the same line */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: Spacing.large,
            }}
          >
            <RBButton
              style={{ padding: Spacing.medium }}
              buttonBackgroundColor={secondaryColor}
              onClick={() => {
                setShowVerificationPopup(false);
                setSelectedVerificationType(stripePadVerificationTypeEnum.Instant);
              }}
              text="Cancel"
            />

            <RBButton
              style={{ padding: Spacing.medium }}
              buttonBackgroundColor={secondaryColor}
              onClick={() => {
                const pharmacy = getActivePharmacy();
                history.push("/padWebpage", {
                  pharmacy: pharmacy,
                  payType: "Shift",
                  selectedVerificationType: selectedVerificationType,
                });
                setShowVerificationPopup(false);
              }}
              text="Next"
            />
          </div>
        </div>
      </RBCardView>

    )
  }
  const renderVerificationTypePopup = () => {
    return (
      <>
        {selectedTransaction !== null &&
          <RBModal
            key={showVerificationPopup ? "open" : "closed"}
            open={showVerificationPopup}
            onClose={closeVerificationPopup}
            modalTitle={"padVerification"}
            header={
              <RBEmptyBlock
                style={{
                  width: "100%",
                  height: Spacing.large,
                  backgroundColor: Colors.defaultGrey,
                  flexShrink: 0,
                }}
              />
            }
            children={
              renderVerificationModal()
            }
          />
        }
      </>
    )
  }
  const onResumeClose= () => {
    setShowPopup(false)
   };
 const renderPaymentPopup = () => {
  console.log("availablePaymentInfo",availablePaymentInfo)
  return(
    <>
    {selectedTransaction != null &&
       <RBModal
       open={showPopup}
       onClose={onResumeClose}
       modalTitle={""
       }
       header={
         <RBEmptyBlock
           style={{
             width: "100%",
             height: Spacing.large,
             backgroundColor: Colors.defaultGrey,
             flexShrink: 0,
           }}
         />
       }
     // actions={() => renderPaymentPopupModalActions()}
       children={
           renderPaymentPopupModal()
       }
     />
    }
    </>
  )
 }

  const renderOptions = () => {
    return(
        <RBCardView style={{
          margin: Spacing.large,
          padding: Spacing.large,
          height: "100%",
        }}>
        <div style={{ padding: 16 }}>
          {/* Banner: warn owner that their current TI will be replaced and cannot be re-selected */}
          {/* {currentPaymentIsInvoice && (
            <div style={{
              backgroundColor: '#FFF3CD',
              border: '1px solid #FFECB5',
              borderRadius: 5,
              padding: 12,
              marginBottom: 16,
              color: '#664D03',
            }}>
              <strong>Note:</strong> Your current payment method is Traditional Invoice.
              If you switch to a different payment method below, you will not be able to switch back to Traditional Invoice.
              To keep Traditional Invoice, go back without making changes.
              Only a Network Administrator can re-assign Traditional Invoice.
            </div>
          )} */}
          <div>
          {optionsArr.length > 0 &&
                <>
                    {optionsArr.map((transaction:any, index:number) => (
                        <div key={index} style={{ marginBottom: 14 }}>
                            <div style={{ flexDirection: 'row', alignItems: 'center' }}>
                            <style>{`
                              input[type="radio"]:checked {
                                accent-color: ${secondaryColor};
                              }
                            `}</style>
                              <input
                                type="radio"
                                id={`paymentOptionId-${index}`}
                                name="paymentOption"
                                value={transaction.type}
                                checked={selectedTransaction === optionsArr[index]}
                                required
                                onChange={() => handleRadioButtonChange(index)}
                                style={{ transform: 'scale(1.5)' }}
                              />
                              <label htmlFor={`paymentOptionId-${index}`} style={{ marginLeft: 8, fontWeight: 'bold', fontSize: 16,  }}>
                                {renderRBPayText(transaction.type)}
                              </label>
                            </div>

                            <div style={{ marginLeft: 50, }}>
                                {optionsArr[index].type === formatPaymentType(paymentTypeEnum.pad) && 
                                <div style={{ textAlign: 'justify', }}>
                                    Stripe Bank Debits & Transfer fees are {transaction.surchargePercentage}% + C${transaction.surchargeFixed} per transaction (capped at C${transaction.padSurchargeMaxCap}). See full details <a style={{textDecorationLine:'underline'}} target="_blank" href={stripePricingURL}>here</a>.
                                </div>}
                                {optionsArr[index].type === formatPaymentType(paymentTypeEnum.creditCard) && 
                                <div style={{ textAlign: 'justify', }}>
                                    Stripe Cards & Wallets fees are {transaction.surchargePercentage}% + C${transaction.surchargeFixed} per transaction. See full details <a style={{textDecorationLine:'underline'}} target="_blank" href={stripePricingURL}>here</a>.
                                </div>}
                                {optionsArr[index].type === formatPaymentType(paymentTypeEnum.invoice) && 
                                <div style={{ textAlign: 'justify', }}>
                                    Payment by e-Transfer or Electronic Funds Transfer (EFT) may incur a processing fee or a late payment fee. Invoices will be sent directly via email. Please contact the Network Administrator if you have any questions about this option.
                                </div>}
                                {optionsArr[index].paymentType === paymentTypeEnum.rbPayroll &&
                                <div style={{ textAlign: 'justify', whiteSpace: 'pre-line', overflowWrap: 'anywhere', lineHeight: 1.5 }}>
                                    {optionsArr[index].description}
                                </div>}

                            </div>

                        </div>
                    ))}
                </>
            }

          </div>
          {selectedTransaction &&
            (
              (selectedTransaction.paymentType === paymentTypeEnum.invoice) ?
                  <div
                  style={{
                    ...ColumnStyle,
                    padding: Spacing.large,
                    marginTop: Spacing.xlarge,
                    marginLeft:"30%",
                    marginRight:"30%",
                  }}
                >
                  <RBButton
                  isLoading={loading}
                  style={{
                    display: "flex",
                    flex: 1,
                    padding: Spacing.medium,
                    margin: Spacing.large,
                  }}
                  buttonBackgroundColor={secondaryColor}
                  onClick={() => {saveInvoicePayment(selectedTransaction.paymentType,false)}}
                  text="Save"
                />
                </div>
                :
                <>
                {
                  <div
                  style={{
                    ...ColumnStyle,
                    padding: Spacing.large,
                    marginTop: Spacing.xlarge,
                    marginLeft:"30%",
                    marginRight:"30%",
                  }}
                >
                  <RBButton
                  style={{
                    display: "flex",
                    flex: 1,
                    padding: Spacing.medium,
                    margin: Spacing.large,
                  }}
                  buttonBackgroundColor={secondaryColor}
                  onClick={() =>  goToPaymentDetails()}
                  text="Next"
                />
                </div>
                }
                 
                </>
                )
          }
          {/* DSO / Care Group message — always visible, below the button */}
          {networkAdminInfo && (() => {
            const admin = networkAdminInfo?.userToNetwork?.[0]?.user?.admin;
            const adminName = admin ? `${admin.firstName} ${admin.lastName}` : null;
            const adminEmail = networkAdminInfo?.userToNetwork?.[0]?.user?.email || null;
            return (
              <div style={{
                backgroundColor: '#FFF8E1',
                border: '1px solid #FFE082',
                borderRadius: 6,
                padding: '12px 16px',
                marginTop: 20,
                marginBottom: 8,
              }}>
                <div style={{ fontWeight: 'bold', marginBottom: 4 }}>
                  Part of a multi-location organization (e.g., DSO or care group)?
                </div>
                <div>
                  Corporate billing options can be arranged through the Network Administrator.
                </div>
                {(adminName || adminEmail) && (
                  <div style={{ marginTop: 6 }}>
                    {adminName && <span style={{ fontWeight: 500 }}>{adminName}</span>}
                    {adminName && adminEmail && <span> | </span>}
                    {adminEmail && (
                      <a href={`mailto:${adminEmail}`} style={{ textDecorationLine: 'underline' }}>
                        {adminEmail}
                      </a>
                    )}
                  </div>
                )}
              </div>
            );
          })()}
        </div>
      </RBCardView>

    )   

  }

  const goToPaymentDetails = async () => {
    const pharmacy = getActivePharmacy();

    if (selectedTransaction?.paymentType === paymentTypeEnum.rbPayroll) {
      await rbPayrollOwnerService.savePaymentOption({
        account,
        location: pharmacy,
        paymentMethod: "RB_PAYROLL",
      });

      // Switching BACK to RB Pay: if the location already has a completed RB Pay
      // setup but its current method isn't rb_pay, re-activate it now (re-save with
      // paymentType "rb_pay") so the location's active method becomes RB Pay again —
      // no banking re-entry. Show a success confirmation; the OK button then opens
      // the RB Pay setup screen. No-op when no profile exists yet (first-time setup
      // proceeds via the form below).
      if (!isRBPayPaymentMethod(pharmacy.paymentType)) {
        const reactivated = await rbPayrollOwnerService.reactivateRBPayrollSetup({
          account,
          location: pharmacy,
        });
        if (reactivated) {
          setRbPayReactivatedOpen(true);
          return;
        }
      }

      history.push(RoutePathConstant.RBPayrollOwnerSetup, {
        selectedLoc: pharmacy,
        newPharmacy,
      });
      return;
    }

    if (account.owner) {
      const selectedLocation = [pharmacy];
      if(!newPaymentType)
      {
        
        
        if(selectedTransaction.paymentType === paymentTypeEnum.pad)
        { 
          
          if(pharmacy.bankAccounts && pharmacy.bankAccounts.length > 0){
            setShowPopup(true)
            setAvailablePaymentInfo(pharmacy.bankAccounts.find((x:any) => x.isDefault));
          }
          else{
            setShowVerificationPopup(true)
          }
            
        }
        else if(selectedTransaction.paymentType === paymentTypeEnum.creditCard){
          
          if(pharmacy.creditCards && pharmacy.creditCards.length > 0){
            if(pharmacy.creditCards.length > 1)
            {
              if (pharmacy.creditCards[0].paymentCardId === pharmacy.creditCards[1].paymentCardId) {
                setShowPopup(false)
                history.push('/paymentCreditInput',{
                  selectedLocation:selectedLocation,
                  payType:'Shift'
                });
                //setAvailablePaymentInfo(pharmacy.creditCards.find(x => x.category == 'shift'));
              } else {
                setShowPopup(true)
                setAvailablePaymentInfoArr(pharmacy.creditCards)
                setSelectedPaymentInfo(pharmacy.creditCards[0])
                setAvailablePaymentInfo(pharmacy.creditCards[0])
              }
            }
            else{
              if(pharmacy.creditCards[0].category == 'job')
              {
                setShowPopup(true)
                setAvailablePaymentInfo(pharmacy.creditCards.find((x:any) =>x.isDefault));
              }
              else{
                setShowPopup(true)
                setAvailablePaymentInfo(pharmacy.creditCards.find((x:any) =>x.isDefault));
              }
             
            }
          }
          else{
            setShowPopup(false)
            history.push('/paymentCreditInput',{
              selectedLocation:selectedLocation,
              payType:'Shift'
            });
          }
        }
      }
      else{
        if(selectedTransaction.paymentType === paymentTypeEnum.pad)
        {
          setShowVerificationPopup(true)
        }
        else if(selectedTransaction.paymentType === paymentTypeEnum.creditCard){
            const selectedLocation = [pharmacy];
            if(pharmacy.creditCards && pharmacy.creditCards.length > 0){
              let jobCreditCard = pharmacy.creditCards.find((x:any) => x.category == 'job')
              if(jobCreditCard){
                setShowPopup(true)
                setAvailablePaymentInfo(pharmacy.creditCards.find((x:any) => x.category == 'job'));
              }
            }
            else{
              history.push('/paymentCreditInput',{
                selectedLocation:selectedLocation,
                payType:'Shift'
              });
            }

            
        }
      }
        
      
        
    } 

  }
  const saveInvoicePayment = async (type:any,copyPayment:any) => {
    const pharmacy = getActivePharmacy();
    try {
      setLoading(true);
      await rbPayrollOwnerService.savePaymentOption({
        account,
        location: pharmacy,
        paymentMethod: "",
      });
      let payload;
      if(copyPayment){
        payload = { locationId: pharmacy.id, paymentType: type,paymentSetupType:'shift',copyPayment:copyPayment }
        if(type === paymentTypeEnum.pad){
          payload = {...payload,padVerificationType:pharmacy?.bankAccounts?.[0]?.verificationType}
          if(pharmacy?.bankAccounts?.[0]?.verificationType === stripePadVerificationTypeEnum.MicroDeposits){
            payload = {...payload,existingBankAccount: true}
          }
        }

        await PharmacyService.createPAD(payload);
      }
      else{
        payload = { locationId: pharmacy.id, paymentType: type,paymentSetupType:'shift'}
        if(type === paymentTypeEnum.pad){
          payload = {...payload,padVerificationType:pharmacy?.bankAccounts?.[0]?.verificationType}
          if(pharmacy?.bankAccounts?.[0]?.verificationType === stripePadVerificationTypeEnum.MicroDeposits){
            payload = {...payload,existingBankSwitch: true}
          }
        }
        await PharmacyService.createPAD(payload);
      }
      setIsAlertShowing(true);
      setAlertInfo({
        title: "Payment info Saved",
        message: `Your payment information has been saved`,
        buttons: [
          <RBButton
            key={"confirm"}
            onClick={async () => {
              setIsAlertShowing(false);
              history.push('/dashboard');
            }}
            buttonBackgroundColor={primaryColor}
            color="primary"
            text="Go Home"
          />,
        ],
      });
     
    } catch (error) {
      setIsAlertShowing(true);
      setAlertInfo({
        title: "Payment info Error",
        message: `Unable to Validate Payment Information`,
        buttons: [
          <RBButton
            key={"confirm"}
            onClick={async () => {
              setIsAlertShowing(false);
              history.push('/dashboard');
            }}
            buttonBackgroundColor={primaryColor}
            color="primary"
            text="Go Home"
          />,
        ],
      });
    } finally {
      setLoading(false);
    }
    
  }

  const renderTabHeader = () => {
    return (
      <RBAppbar
        deeperLevel={true}
        barName={"Payment Options"}
      />
    );
  };

  const handleRadioButtonChange = (index:number) => {
    //if edit mode is true, checked payment type detail is not saved already then hide "Save" and "Update" buttons,enable "Next" button
    if(editMode)
    {
      //check payment type details already exist or not
      setNewPaymentType(true);
      const pharmacy = getActivePharmacy();
      if(optionsArr[index].paymentType === paymentTypeEnum.pad){
        if(pharmacy.bankAccounts && pharmacy.bankAccounts.length > 0){
          setNewPaymentType(false);
        }
      }
      else if(optionsArr[index].paymentType === paymentTypeEnum.creditCard){
        if(pharmacy.creditCards && pharmacy.creditCards.length > 0){
          setNewPaymentType(false);
        }
      }
      else if(optionsArr[index].paymentType === paymentTypeEnum.rbPayroll){
        const hasSavedRBPayroll = rbPayrollOptions.some((option) => option.selected);
        if(hasSavedRBPayroll){
          setNewPaymentType(false);
        }
      }

    }
    


    setSelectedTransaction(optionsArr[index]);
  };
  const theme = useTheme();
  return (
    <>
    {isPageLoading ? (
      <LoadingIndicator />
    ) : (
      <>
   
        <div>
        <RBAlert
          show={isAlertShowing}
          alertTitle={alertInfo.title}
          alertMessage={alertInfo.message}
          buttons={alertInfo.buttons}
        />
          {renderTabHeader()}
          {renderOptions()}
          {renderPaymentPopup()}
          {renderVerificationTypePopup()}

          <RBAlert
            show={rbPayReactivatedOpen}
            alertTitle="RB Pay Re-activated"
            alertMessage="RB Pay is now set as the payment method for this location."
            buttons={[
              <RBButton
                key="ok"
                text="OK"
                buttonBackgroundColor={secondaryColor}
                onClick={() => {
                  setRbPayReactivatedOpen(false);
                  history.push(RoutePathConstant.RBPayrollOwnerSetup, {
                    selectedLoc: getActivePharmacy(),
                    newPharmacy,
                  });
                }}
              />,
            ]}
          />

        </div>
        </>
      )}

    </>
    );
}

